/**
 * Available tags for vehicles in the system.
 * These tags help categorize and describe vehicles in a standardized way.
 */
export const AVAILABLE_TAGS = [
  "Accident", // Accident/damaged vehicles
  "Funny", // Humorous aspects
  "Viral", // Internet famous vehicles
  "Exotic", // Rare/exotic vehicles
  "ATBGE", // Awful Taste But Great Execution
  "Ricer", // Questionable modifications
  "Sleeper", // Unassuming but powerful
  "Royal", // VIP/official vehicles
  "Dato/VIP", // Dato/VIP vehicles
  "Diplomat", // Diplomatic vehicles (red plates)
  "Taxi", // Taxi vehicles
  "Vanity", // Custom/vanity plates
  "Modified", // Significantly modified vehicles
  "Upbadge", // False badge upgrades
  "Downbadge", // Debadged or lower badge
  "Rare", // Rare/interesting sightings
  "Vintage", // Classic/old vehicles
  "Celebrity", // Celebrity owned/related
  "Abandoned", // Abandoned/neglected vehicles
  "Parking", // Parking lot vehicles/bad parking
  "Suspicious", // Suspicious vehicles
  "Road Rage", // Asshole drivers
  "P Sticker", // P license sticker
  "Damaged", // Damaged vehicles
  "Common", // Commonly seen vehicles
];
